import { render, staticRenderFns } from "./PrePostField.vue?vue&type=template&id=b9f0a3de&scoped=true"
import script from "./PrePostField.vue?vue&type=script&lang=js"
export * from "./PrePostField.vue?vue&type=script&lang=js"
import style0 from "./PrePostField.vue?vue&type=style&index=0&id=b9f0a3de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f0a3de",
  null
  
)

export default component.exports